var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditChat = function SvgEditChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    style: {
      color: "#d6e5f2"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.286 14.3.007-.007 7-7 3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-10 10A1 1 0 0 1 9 19H6a1 1 0 0 1-1-1v-3.031a.997.997 0 0 1 .286-.67ZM9 16.586 14.586 11 13 9.414 7.414 15 9 16.586ZM14.414 8 16 9.586 17.586 8 16 6.414 14.414 8Z",
    clipRule: "evenodd"
  })));
};
export default SvgEditChat;